import { useNavigate, useParams } from "react-router-dom";
import { GetUserById, UpdateUser } from "../../../services/userService";
import { useCallback, useEffect, useState } from "react";

const StaffEdit=()=>{
const navigate = useNavigate();
const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
const[message,setMessage]=useState("");
    const { id } = useParams();
    const [formData, setFormData] = useState({
        id: 0,
        userName: "",
        email: "",
        mobileNo: "",
        // password: "",
        // roleId: "",
        // parentId: "",
        status: true
    });

    const loadUser = useCallback(async () => {
    try {
        const response = await GetUserById(id);
        if (response.success) {
            setFormData({
                id: response.data.id,
                userName: response.data.userName,
                email: response.data.email,
                mobileNo: response.data.mobileNo,
                // password: "",
                // roleId: response.data.roleId,
                // parentId: response.data.parentId,
                status: response.data.status === "Active"
            });
        }
        else {
                setMessage("User not found.");
            }
    } catch (err) {
        console.log(err);
        setMessage("Failed to load user.");
        } finally {
            setPageLoading(false);
        }
}, [id]);

useEffect(() => {
    if (id) {
        loadUser();
    }
}, [id, loadUser]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();
if (!formData.userName.trim()) {
            alert("Please enter user name.");
            return;
        }

        if (!formData.email.trim()) {
            alert("Please enter email.");
            return;
        }

        if (!formData.mobileNo.trim()) {
            alert("Please enter mobile number.");
            return;
        }
        try {
setLoading(true);

            let response;
                 console.log(formData);
                response = await UpdateUser(formData);
                console.log(response);
            if (response.data.statusCode===200 && response.data.success) {
                alert("User Updated Successfully");
                navigate("/staffList");
            } else {
                alert(response.message);
            }

        } catch (err) {

            console.log(err);

        }finally{
            setLoading(false);
        }

    };
 if (pageLoading) {
        return <h5 className="text-center mt-5">Loading...</h5>;
    }
   return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4>Edit Staff</h4>
                </div>

                <div className="card-body">

                    {message && (
                        <div className="alert alert-danger">
                            {message}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>

                        <div className="mb-3">
                            <label className="form-label">
                                User Name
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                name="userName"
                                value={formData.userName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                Email
                            </label>

                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                Mobile Number
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                name="mobileNo"
                                value={formData.mobileNo}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-check mb-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="status"
                                checked={formData.status}
                                onChange={handleChange}
                                id="status"
                            />

                            <label
                                className="form-check-label"
                                htmlFor="status"
                            >
                                Active
                            </label>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary me-2"
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update User"}
                        </button>

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => navigate("/staffList")}
                        >
                            Cancel
                        </button>

                    </form>
                </div>
            </div>
        </div>
    );
};
export default StaffEdit;
